import { React } from "react";
import styled from "styled-components";
import { Button, PageHeader } from "antd";
import { HaberForm, PageTitleComp } from "../../Pages/styledElements";
import SearchIcon from "../../Assets/Icons/search.svg";
import { useLocation, useNavigate } from "react-router";

const Header = styled.div`
  .searchBoxWrap {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
  }
  .searchWidth {
    width: 38%;
    .ant-row {
      margin: 0;
    }
  .ant-page-header-heading-title {
    color: var(--black-color);
    font-size: 28px;
    line-height: 36px;
    font-family: var(--sf-pro-display-m);
    font-weight: 500;
    margin: 0px
  }
  svg {
    color: var(--main-title);
  }
  .ant-page-header{
    padding: 16px 0px;
  }
`;

const LogHeader = (props) => {
  const data = props.data;
  const location = useLocation();
  const navigate = useNavigate();

  const routeBack = () => {
    if (data.product) {
      navigate(data.product.route, {
        state: {
          productCode: data.product.productCode,
          action: data.product.action,
          roles : data.product.roles
        },
      });
    }
    if (data.customer) {
        navigate(data.customer.route, {
          state: {
            customercode: data.customer.customercode,
            action: data.customer.action,
            roles : data.customer.roles
          },
        });
      }
      if (data.order) {
        navigate(data.order.route, {
          state: {
            selectedOrder: data.order.orderDetails,
            route: data.order.PORoute,
            backKey: data.order.backKey,
            values :  data.order.values,
            defaultActiveKey: data.order.defaultActiveKey,
            defaultOrderState: data.order.defaultOrderState
          },
        });
      }
      if(data.deckleOrder){
        navigate("/deckle-matching/order-records/", {
          state: {
            selectedOrder: data.deckleOrder.orderDetails,
            backKey: data.deckleOrder.backKey,
          },
        });
      }
  };
  return (
        <PageTitleComp className="marginRightAdg">
          <PageHeader
            ghost={false}
            onBack={routeBack}
            title={props.title}
            extra={[]}
          ></PageHeader>
         </PageTitleComp>
  );
};
export default LogHeader;
